module.exports = __webpack_public_path__ + "../resources/img/ic_info.3ee60765.svg";